import { AsyncPipe, ViewportScroller } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { OverviewPageBase } from '@zero/crypto/feature-crypto-overview/base';
import { CryptoList, CryptoListComponent } from '../../components/crypto-list/crypto-list.component';
import { ETPListComponent } from '../../components/etplist/etplist.component';

@Component({
  selector: 'crypto-overview-page',
  templateUrl: './overview-page.component.html',
  imports: [CryptoListComponent, ETPListComponent, AsyncPipe],
})
export class OverviewPageComponent extends OverviewPageBase implements OnInit, OnDestroy {
  readonly #viewportScroller = inject(ViewportScroller);

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.destroy();
  }

  public scrollTo(event: CryptoList) {
    if (event === 'ETPS') {
      this.#viewportScroller.scrollToAnchor('etp-list');
    } else {
      this.#viewportScroller.scrollToAnchor('crypto-list');
    }
  }
}
